import type { BlessingName } from './types';

export const defaultBlessings: readonly BlessingName[] = [
    'alpaca',
    'buddha-normal',
    'buddha-with-poetry',
    'cat',
    'dragon',
    'gopher',
    'guāiguāi',
];
